import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "timer-confirmation-modal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "counterTitle" }, "Você esperou os 15 minutos?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-content upperSpace" }, " A leitura do resultado deve ser realizada após o tempo indicado. Continue para o próximo passo se você já fez o procedimento. ", -1)
const _hoisted_4 = { class: "action-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-default btn-secondary upperSpace buttonSmall",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
          }, " Aguardar "),
          _createElementVNode("button", {
            class: "btn btn-default btn-primary upperSpace buttonLarge",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goAhead()))
          }, " Continuar ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}